import "./App.css";
import Navbar from "./components/Navbar/Navbar.js";
import AutoSlider from "./components/autoSlider/AutoSlider.js";
import Services from "./components/Services/Services";
import ContactUs from "./components/Contact Us/ContactUs";
import JoinUs from "./components/Join Us/JoinUs";
import Footer from "./components/Footer/Footer.js";
import AboutUs from "./components/App/App.js";
// import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.9.1/font/bootstrap-icons.css"
      ></link>
      <Navbar />
      <AutoSlider />
      <div className="gap-section"></div>
      <AboutUs />
      <div className="gap-section"></div>
      <Services />
      <div className="gap-section"></div>
      <ContactUs />
      <div className="gap-section"></div>
      <JoinUs />
      <div className="gap-section"></div>
      <Footer />

      {/* <Routes>
        <Route path="/" element={<StartUp />} />
        <Route path="Navbar/*" element={<Navbar />} />
        <Route path="ContactUs/*" element={<ContactUs />} />
      </Routes> */}
    </div>
  );
}

export default App;
